// extracted by mini-css-extract-plugin
export default {"excess":"XYyJANqnpnWBIgjTlBPF2","totalExcess":"_3xi66otR1iAvUDM9hNzqvh","infoBoxOverride":"_2W1hcHyqfsKz_ceqnx7h9x"};